export const PAGE_SIZE_10 = 10;
export const CLEAN_AUTH = "CLEAN_AUTH";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const GET_PROFILE = "GET_PROFILE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const CLEAN_NAV = "CLEAN_NAV";
export const PREREGISTER_EMPLOYEE = "PREREGISTER_EMPLOYEE";

export const ROLE_EVALUATOR = "evaluator";
export const ROLE_EVALUATED = "evaluated";
export const ROLE_MANAGER = "manager";
export const ROLE_EVALUATOR_MANAGER = "evaluator_manager";
export const ROLE_ADMIN = "admin";
export const ROLE_STAFF = "staff";

export const LANGUAGE_ES = {
  code: "es",
  label: "language.languages.es",
};
export const LANGUAGE_EN = {
  code: "en",
  label: "language.languages.en",
};
export const LANGUAGE_PT = {
  code: "pt",
  label: "language.languages.pt",
};

export const LANGUAGES = [LANGUAGE_ES, LANGUAGE_PT];

export const STATUS_OPEN = {
  code: "OPEN",
  label: "status.open",
};

export const STATUS_CLOSE = {
  code: "CLOSE",
  label: "status.close",
};

export const STATUS_BLOCKED = {
  code: "BLOCKED",
  label: "status.blocked",
};

export const STATUS = [STATUS_OPEN, STATUS_CLOSE, STATUS_BLOCKED];

export const EVAL_STATUS_PENDING = {
  code: "PENDING",
  label: "forms.evaluation.status.pending",
  icon: "fa-solid fa-hourglass-half",
  color: "#9e9e9e",
};

export const EVAL_STATUS_DRAFT = {
  code: "DRAFT",
  label: "forms.evaluation.status.draft",
  icon: "fa-solid fa-file-pen",
  color: "#2196f3",
};

export const EVAL_STATUS_CONFIRM = {
  code: "CONFIRM",
  label: "forms.evaluation.status.confirm",
  icon: "fa-solid fa-clipboard-check",
  color: "#03a9f4",
};

export const EVAL_STATUS_TO_AUTO = {
  code: "TO_AUTO_EVAL",
  label: "forms.evaluation.status.toAuto",
  icon: "fa-solid fa-user-pen",
  color: "#ff9800",
};

export const EVAL_STATUS_AUTO_EVAL = {
  code: "AUTO_EVALUATED",
  label: "forms.evaluation.status.autoEval",
  icon: "fa-solid fa-user-check",
  color: "#ffc107",
};

export const EVAL_STATUS_TO_EVAL = {
  code: "TO_EVAL",
  label: "forms.evaluation.status.toEval",
  icon: "fa-solid fa-user-tie",
  color: "#ff5722",
};

export const EVAL_STATUS_EVALUATED = {
  code: "EVALUATED",
  label: "forms.evaluation.status.evaluated",
  icon: "fa-solid fa-flag-checkered",
  color: "#4caf50",
};

export const EVAL_STATUS_CALIBRATED = {
  code: "CALIBRATED",
  label: "forms.evaluation.status.calibrated",
};

export const EVAL_STATUS_PENDING_CALIBRATED = {
  code: "PENDING_CALIBRATED",
  label: "forms.evaluation.status.pendingCalibrated",
};

export const EVAL_STATUS_NOTIFIED = {
  code: "NOTIFIED",
  label: "forms.evaluation.status.notified",
  icon: "fa-solid fa-envelope-circle-check",
  color: "#8bc34a",
};

export const EVAL_STATUS_ARCHIVED = {
  code: "ARCHIVED",
  label: "forms.evaluation.status.archived",
};

export const EVAL_STATUS = [
  EVAL_STATUS_PENDING,
  EVAL_STATUS_DRAFT,
  EVAL_STATUS_CONFIRM,
  EVAL_STATUS_TO_AUTO,
  EVAL_STATUS_AUTO_EVAL,
  EVAL_STATUS_TO_EVAL,
  EVAL_STATUS_EVALUATED,
  EVAL_STATUS_CALIBRATED,
  EVAL_STATUS_PENDING_CALIBRATED,
  EVAL_STATUS_NOTIFIED,
  EVAL_STATUS_ARCHIVED,
];
export const POINT_NOT = {
  code: -2,
  label: "points.not",
};

export const POINT_NA = {
  code: -1,
  label: "points.pointNA",
};

export const POINT01 = {
  code: 1,
  label: "points.point01",
};

export const POINT02 = {
  code: 2,
  label: "points.point02",
};

export const POINT03 = {
  code: 3,
  label: "points.point03",
};

export const POINT04 = {
  code: 4,
  label: "points.point04",
};

export const POINT05 = {
  code: 5,
  label: "points.point05",
};

export const POINTS = [POINT01, POINT02, POINT03, POINT04, POINT05, POINT_NA];

export const POINTS_ALL = [
  POINT01,
  POINT02,
  POINT03,
  POINT04,
  POINT05,
  POINT_NA,
  POINT_NOT,
];

export const DEPARTMENT_ADMINISTRACION_CGSI = {
  code: "ADMINISTRACION_CGSI",
  label: "forms.report.departments.administracion_cgsi",
};

export const DEPARTMENT_CONTROL_GESTION = {
  code: "CONTROL_GESTION",
  label: "forms.report.departments.control_gestion",
};

export const DEPARTMENT_SISTEMAS_INFORMACION = {
  code: "SISTEMAS_INFORMACION",
  label: "forms.report.departments.sistemas_informacion",
};

export const DEPARTMENT_CONTABILIDAD = {
  code: "CONTABILIDAD",
  label: "forms.report.departments.contabilidad",
};

export const DEPARTMENT_FINANCIERO_TESORERIA = {
  code: "FINANCIERO_TESORERIA",
  label: "forms.report.departments.financiero_tesoreria",
};

export const DEPARTMENT_FRUTOS_SECOS = {
  code: "FRUTOS_SECOS",
  label: "forms.report.departments.frutos_secos",
};

export const DEPARTMENT_INVERSIONES_PT = {
  code: "INVERSIONES_PT",
  label: "forms.report.departments.inversiones_pt",
};

export const DEPARTMENT_LEGAL_COMPLIANCE_ESG = {
  code: "LEGAL_COMPLIANCE_ESG",
  label: "forms.report.departments.legal_compliance_esg",
};

export const DEPARTMENT_OLIVAR = {
  code: "OLIVAR",
  label: "forms.report.departments.olivar",
};

export const DEPARTMENT_SOPORTE_NEGOCIO = {
  code: "SOPORTE_NEGOCIO",
  label: "forms.report.departments.soporte_negocio",
};

export const DEPARTMENT_OPERACIONES_AREA = {
  code: "OPERACIONES_AREA",
  label: "forms.report.departments.operaciones_area",
};

export const DEPARTMENT_CALIDAD_LAB_IDI = {
  code: "CALIDAD_LAB_IDI",
  label: "forms.report.departments.calidad_lab_idi",
};

export const DEPARTMENT_COMERCIAL = {
  code: "COMERCIAL",
  label: "forms.report.departments.comercial",
};

export const DEPARTMENT_COMPRAS = {
  code: "COMPRAS",
  label: "forms.report.departments.compras",
};

export const DEPARTMENT_INDUSTRIA = {
  code: "INDUSTRIA",
  label: "forms.report.departments.industria",
};

export const DEPARTMENT_LOGISTICA = {
  code: "LOGISTICA",
  label: "forms.report.departments.logistica",
};

export const DEPARTMENT_OPERACIONES = {
  code: "OPERACIONES",
  label: "forms.report.departments.operaciones",
};

export const DEPARTMENT_AGR = {
  code: "AGR",
  label: "forms.report.departments.agr",
};

export const DEPARTMENT_RRHH_COMUNICACION_SSGG = {
  code: "RRHH_COMUNICACION_SSGG",
  label: "forms.report.departments.rrhh_comunicacion_ssgg",
};

export const DEPARTMENT_COMUNICACION = {
  code: "COMUNICACION",
  label: "forms.report.departments.comunicacion",
};

export const DEPARTMENT_DESARROLLO_ORGANIZATIVO = {
  code: "DESARROLLO_ORGANIZATIVO",
  label: "forms.report.departments.desarrollo_organizativo",
};

export const DEPARTMENT_GESTION_RRHH = {
  code: "GESTION_RRHH",
  label: "forms.report.departments.gestion_rrhh",
};

export const DEPARTMENT_FLOTA = {
  code: "FLOTA",
  label: "forms.report.departments.flota",
};

export const DEPARTMENT_SEGURIDAD_SALUD_LABORAL = {
  code: "SEGURIDAD_SALUD_LABORAL",
  label: "forms.report.departments.seguridad_salud_laboral",
};

export const DEPARTMENT_RRHH_PORTUGAL = {
  code: "RRHH_PORTUGAL",
  label: "forms.report.departments.rrhh_portugal",
};

export const DEPARTMENT_ENERGIA_CONTRAINCENDIOS_SEGURIDAD = {
  code: "ENERGIA_CONTRAINCENDIOS_SEGURIDAD",
  label: "forms.report.departments.energia_contraincendios_seguridad",
};

export const DEPARTMENT_MANTENIMIENTO = {
  code: "MANTENIMIENTO",
  label: "forms.report.departments.mantenimiento",
};

export const DEPARTMENT_DEPARTAMENTO_OPERACIONES = {
  code: "DEPARTAMENTO_OPERACIONES",
  label: "forms.report.departments.departamento_operaciones",
};

export const DEPARTMENT_RRHH = {
  code: "RRHH",
  label: "forms.report.departments.rrhh",
};

export const DEPARTMENT_LEGAL = {
  code: "LEGAL",
  label: "forms.report.departments.legal",
};

export const DEPARTMENT_FINANCIERO = {
  code: "FINANCIERO",
  label: "forms.report.departments.financiero",
};

export const DEPARTMENT_INVERSIONES = {
  code: "INVERSIONES",
  label: "forms.report.departments.inversiones",
};

export const DEPARTMENT_ADM = {
  code: "ADM",
  label: "forms.report.departments.adm",
};

export const DEPARTMENT_FRUTOSSECOs_ALIAS = {
  code: "FRUTOSSECOS_ALIAS",
  label: "forms.report.departments.frutossecos",
};

export const DEPARTMENT_INDUSTRIA_SIMPLE = {
  code: "INDUSTRIA_SIMPLE",
  label: "forms.report.departments.industria_simple",
};

export const DEPARTMENTS = [
  DEPARTMENT_ADMINISTRACION_CGSI,
  DEPARTMENT_CONTROL_GESTION,
  DEPARTMENT_SISTEMAS_INFORMACION,
  DEPARTMENT_CONTABILIDAD,
  DEPARTMENT_FINANCIERO_TESORERIA,
  DEPARTMENT_FRUTOS_SECOS,
  DEPARTMENT_INVERSIONES_PT,
  DEPARTMENT_LEGAL_COMPLIANCE_ESG,
  DEPARTMENT_OLIVAR,
  DEPARTMENT_SOPORTE_NEGOCIO,
  DEPARTMENT_OPERACIONES_AREA,
  DEPARTMENT_CALIDAD_LAB_IDI,
  DEPARTMENT_COMERCIAL,
  DEPARTMENT_COMPRAS,
  DEPARTMENT_ENERGIA_CONTRAINCENDIOS_SEGURIDAD,
  DEPARTMENT_INDUSTRIA,
  DEPARTMENT_LOGISTICA,
  DEPARTMENT_MANTENIMIENTO,
  DEPARTMENT_DEPARTAMENTO_OPERACIONES,
  DEPARTMENT_AGR,
  DEPARTMENT_RRHH_COMUNICACION_SSGG,
  DEPARTMENT_COMUNICACION,
  DEPARTMENT_DESARROLLO_ORGANIZATIVO,
  DEPARTMENT_GESTION_RRHH,
  DEPARTMENT_FLOTA,
  DEPARTMENT_SEGURIDAD_SALUD_LABORAL,
  DEPARTMENT_RRHH_PORTUGAL,
];
